export default __webpack_public_path__ + "../staticImages/newsletter_step_goal.svg";